import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './DayHeader.scss';

const DayHeader = (props) => {
    const {
        className,
        dayNames,
    } = props;

    return (
        <tr>
            {dayNames.map((dayName, i) => (
                <th
                    className={classNames(className, styles.dayHeader)}
                    key={i}
                >
                    {dayName}
                </th>
            ))}
        </tr>
    );
};

DayHeader.propTypes = {
    className: PropTypes.string,
    dayNames: PropTypes.arrayOf(PropTypes.string).isRequired,
};

DayHeader.defaultProps = {
    className: '',
};

export default DayHeader;
